import List from './List.vue'
import Form from './Form.vue'
import EmailStatus from './EmailStatus.vue'
import Filters from './Filters.vue'

export default {
  install (Vue) {
    Vue.component('emails-list', List)
    Vue.component('emails-form', Form)
    Vue.component('email-status', EmailStatus)
    Vue.component('email-filters', Filters)
  }
}



// WEBPACK FOOTER //
// ./src/components/emails/index.js